import { render } from "./MyOrderItems.vue?vue&type=template&id=4f690b5f&scoped=true"
import script from "./MyOrderItems.vue?vue&type=script&lang=js"
export * from "./MyOrderItems.vue?vue&type=script&lang=js"

import "./MyOrderItems.vue?vue&type=style&index=0&id=4f690b5f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f690b5f"]])

export default __exports__